import React from 'react';
import Navbar from './components/Navbar';
import Home from './components/pages/Home';
import TBD from './components/pages/TBD';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Footer from './components/Footer';
import HPE from './components/pages/HPE';
import WorkTermOne from './components/pages/WorkTermOne';
import WorkTermTwo from './components/pages/WorkTermTwo';
import WorkTermThree from './components/pages/WorkTermThree'
import WorkTermFour from './components/pages/WorkTermFour';
import WorkTermFive from './components/pages/WorkTermFive';


function App() {
  return (
    <>
      <Router>
        <Navbar/>
        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='/tbd' element={<TBD/>} />
          <Route path='/hpe' element={<HPE/>}/>
          <Route path='/work-term-one' element={<WorkTermOne/>}/>
          <Route path='/work-term-two' element={<WorkTermTwo/>}/>
          <Route path='/work-term-three' element={<WorkTermThree/>}/>
          <Route path='/work-term-four' element={<WorkTermFour/>}/>
          <Route path='/work-term-five' element={<WorkTermFive/>} />
        </Routes>
        <Footer/>
      </Router>
    </>
  );
}

export default App;
